import { ToggleProps } from './index'
import styles from './styles.module.scss'

const ToggleBothSides = ({
  labelA,
  labelB,
  toggled,
  labelDir = 'right',
  onToggle,
  classes = ''
}: ToggleProps) => {
  const containerClass = [
    styles.Toggle,
    toggled ? styles.on : styles.off,
    styles[labelDir],
    styles.bothSides,
    classes
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={containerClass}>
      {labelA && <span className={styles.Toggle__label}>{labelA}</span>}
      <button
        className={styles.Toggle__button}
        onClick={onToggle}
        name="toggle"
        aria-label="toggle unit"
      >
        <span className={styles.Toggle__slider} />
      </button>
      {labelB && <span className={styles.Toggle__label}>{labelB}</span>}
    </div>
  )
}

export default ToggleBothSides
